import { Link as LinkDS } from '@cash-me/react-components'
import styled, { css } from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};

  .ds-button {
    width: 100%;
    justify-content: center;
  }

  a {
    text-decoration: underline;
  }

  @media (${media.tablet}) {
    gap: ${space['spacing-md']};
  }
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;

  small {
    margin-bottom: calc(${space['spacing-xxxs']} + 1px);
  }

  > * {
    padding: 0;
    margin: 0;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    appearance: textfield;
  }

  @media (${media.tablet}) {
    gap: ${space['spacing-xxs']};
  }
`

export const OptionsTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
`

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};

  small {
    margin-bottom: calc(${space['spacing-xxxs']} + 1px);
  }

  > * {
    padding: 0;
    margin: 0;
  }
`

export const Link = styled(LinkDS)`
  display: unset;
  cursor: pointer;
  line-height: unset;
  color: ${colors['blue-text-default']};

  &::after {
    display: none;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 48px;
`

export const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${space['spacing-md']};
  margin-bottom: ${space['spacing-xxs']};
`

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${space['spacing-xxs']};
  margin-top: ${space['spacing-xl']};
`

const FlexInBlue = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${space['spacing-sm']};
`

export const BlueBox = styled.div`
  ${FlexInBlue}
  width: 100%;
  padding: ${space['spacing-sm']};
  background-color: #f3f6ff;
  border: 1px #bdceff solid;
  border-radius: ${radii['corner-radius-md']};
  margin-top: ${space['spacing-sm']};

  > a {
    ${FlexInBlue}
    cursor: pointer;
  }

  > ${LoaderWrapper} {
    margin-top: 0;
  }

  > p {
    & > b,
    & > a {
      display: inline-block;
    }

    & > a {
      overflow-wrap: anywhere;
      color: ${colors['neutral-text-default']};
      font-weight: 700;
      text-decoration: underline;
    }
  }
`
